import { ACTIONS } from 'actions/student-course-trial-upgrade';
import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.EMPTY_STORE_DATA:
      return payload;
    default:
      return state;
  }
});
